module.exports = __webpack_public_path__ + "2fc28d903d6372375a59de53ddb8b06c.MP3";